/* import __COLOCATED_TEMPLATE__ from './contact-section.hbs'; */
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class SiteDocumentsContactInfoContactSection extends Component {}
